import { useCommon } from '@/core/useCommon'
import usePermissions from '@/hooks/usePermissions'
import { useMemo } from 'react'
import PendingReviewIcon from './assets/pending-review.svg'
import PendingPaymentIcon from './assets/pending-payment.svg'
import TodayRechNumIcon from './assets/today-rech-num.svg'
import TodayWithdrawNumIcon from './assets/today-withdraw-num.svg'
import { usePaymentOverview } from '@/hooks/user/usePaymentOverview'
import { cn } from '@/styles'

// 待審核、待出款、今日出款、今日充值
const PaymentOverview = () => {
  const { t, push } = useCommon()
  const { isStation } = usePermissions()
  const { overviewMaps } = usePaymentOverview()

  const list = useMemo(() => {
    return [
      {
        ...overviewMaps.pendingReview,
        icon: <PendingReviewIcon />,
        alert: overviewMaps.pendingReview.value > 0, // 變成紅底
      },
      {
        ...overviewMaps.pendingPayment,
        icon: <PendingPaymentIcon />,
        alert: overviewMaps.pendingPayment.value > 0, // 變成紅底
      },
      {
        ...overviewMaps.todayWithdrawNum,
        icon: <TodayWithdrawNumIcon />,
        alert: false,
      },
      {
        ...overviewMaps.todayRechNum,
        icon: <TodayRechNumIcon />,
        alert: false,
      },
    ]
  }, [t, overviewMaps])

  // 不是投注站的話不顯示這頁
  if (!isStation) return null

  return (
    <div className="mt-16 flex w-full flex-col gap-12 px-10 text-[#FFFFFF]">
      {list?.map((item, index) => (
        <div key={index} className="flex items-center gap-8">
          {/* icon */}
          {!!item.icon && <div className="text-[#E3E9FA]">{item.icon}</div>}

          <div className="flex items-center gap-4">
            <div className="sm:text-14 capitalize sm:leading-16">{item?.label}</div>

            <div
              className={cn('sm:text-14 rounded-4 cursor-pointer px-4 sm:leading-16', {
                'bg-[#FF4343]': item.alert,
              })}
              onClick={() => {
                if (!item.link) return
                push(item?.link)
              }}>
              {item?.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PaymentOverview
